// extracted by mini-css-extract-plugin
module.exports = {"inputMessage":"AddMessgaeChat_inputMessage__Swv7d","inputText":"AddMessgaeChat_inputText__1Kzyx","buttonInput":"AddMessgaeChat_buttonInput__WFqSJ"};